import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

import RestClient from "src/services/rest"
import StatisticsCard, { VariationType } from "../statisticsCard"
import formatDuration from "src/lib/formatDuration"

const DashboardWorkedHours: React.FC = () => {
  const { partnerId } = useParams()
  const [loading, setLoading] = useState(true)
  const [total, setTotal] = useState(0)
  const [variation, setVariation] = useState(0)
  const [variationType, setVariationType] = useState<VariationType>("none")

  useEffect(() => {
    fetchWorkedHours(partnerId)
      .then((workedHours) => {
        setTotal(workedHours.total)
        setVariation(workedHours.variation)
        setVariationType(workedHours.variationType as VariationType)
      })
      .finally(() => setLoading(false))
  }, [])

  return (
    <StatisticsCard
      title="Worked hours by Roberty"
      data={formatDuration(total, "HH[h]mm[m]")}
      variation={formatDuration(variation, "HH[h]mm[m]")}
      variationType={variationType}
      loading={loading}
    />
  )
}

async function fetchWorkedHours(partnerId: string) {
  return await RestClient.Dashboard.WorkedHours.get(partnerId)
}

export default DashboardWorkedHours